import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminBoxContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeDeleted!: boolean;

  @jsonMember(Boolean)
  public readonly canBeBoxSaleCreated!: boolean;

  @jsonMember(Boolean)
  public readonly canBeBoxSaleViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeWarehouseGoodIdEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeOrdersCompleted!: boolean;

  @jsonMember(Boolean)
  public readonly canBeOrdersCompletedSimulated!: boolean;

  @jsonMember(Boolean)
  public readonly canDownloadLabels!: boolean;
}
